import { createContext } from 'react'
import { RoutesFormDataObject } from './contextDataObjects/RoutesDataObject'

interface IRoutesFormData {
    location: string,
    language: string
}
interface RoutesFormDataContextValue {
    routesFormData: IRoutesFormData
    setRoutesFormData: React.Dispatch<React.SetStateAction<IRoutesFormData>>
}

const RoutesFormDataContext = createContext<RoutesFormDataContextValue>({
    routesFormData: RoutesFormDataObject,
    setRoutesFormData: () => { },
})

export default RoutesFormDataContext